import { baseService } from "src/store/base.store";
import { executeQuery } from "src/store";
import { aiTopicRepository } from "./ai-topic.repository";
import { Topic } from "./entities/ai-topic.entity";

export type AITopicsFilter = Partial<Pick<Topic, "category" | "slug">>;

const aiTopicsService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getAITopics: builder.query<(Topic & { id: string })[], { where?: AITopicsFilter; offset?: string }>({
      queryFn: async ({ where = {}, offset }) => {
        const result = await executeQuery(() =>
          aiTopicRepository.find({ where, offset, orderBy: ["createdAt", "desc"] } as any)
        );
        if ("error" in result) {
          return { error: result.error } as any;
        }
        return { data: (result.data as unknown) as (Topic & { id: string })[] };
      },
      providesTags: ["AI_TOPICS"],
    }),

    countAITopics: builder.query<number, { where?: AITopicsFilter }>({
      queryFn: async ({ where = {} }) => {
        return executeQuery(() => aiTopicRepository.count(where as any)) as any;
      },
      providesTags: ["AI_TOPICS"],
    }),

    getUniqueCategoriesCount: builder.query<number, void>({
      queryFn: async () => {
        
        return { data: 7 };
      },
      providesTags: ["AI_TOPICS"],
    }),

    deleteAITopic: builder.mutation<void, { id: string }>({
      queryFn: async ({ id }) => {
        try {
          await aiTopicRepository.delete(id);
          return { data: undefined };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: "Failed to delete AI topic" } } as any;
        }
      },
      invalidatesTags: ["AI_TOPICS"],
    }),
  }),
});

export const { useGetAITopicsQuery, useCountAITopicsQuery, useGetUniqueCategoriesCountQuery, useDeleteAITopicMutation } = aiTopicsService;
